/* minbox push events */
import * as types from './eventTypes';

const pushToDashamail = (type, data) => {
  const { dashamail } = window || {};

  if (dashamail) {
    switch (type) {
      case types.EVENT_MAIL_SUBSCRIPTION: {
        const { email, widgetPosition } = data;

        dashamail('async', {
          operation: 'UserSubscribe',
          data: {
            customer: {
              email,
              subscriptions: [
                {
                  pointOfContact: 'Email',
                  topic: 'General',
                },
              ],
            },
            pointOfContact: widgetPosition,
          },
        });
        break;
      }
      case types.EVENT_LOAD_DETAILS: {
        const { id, price } = data;

        dashamail('async', {
          operation: 'beelineCustomerViewProduct',
          data: {
            viewProduct: {
              product: {
                ids: {
                  beelineBackendSystem: id,
                },
              },
            },
          },
        });
        dashamail('async', {
          operation: 'DobavlenieProduktaVProsmotrennye',
          data: {
            addProductToList: {
              product: {
                ids: {
                  beelineBackendSystem: id,
                },
              },
              price,
            },
          },
        });
        break;
      }
      case types.EVENT_CATALOG_LOAD: {
        const { subCollectionId } = data;

        if (subCollectionId) {
          dashamail('async', {
            operation: 'beelineCustomerViewCategory',
            data: {
              viewProductCategory: {
                productCategory: {
                  ids: {
                    beelineBackendSystem: subCollectionId,
                  },
                },
              },
            },
          });
        }
        break;
      }
      default:
        return false;
    }
  }

  return true;
};

export default pushToDashamail;
